<template>
  <div class="star">
    <slot></slot>
  </div>
</template>

<script>
  import { Graphics, Text } from 'pixi.js-legacy'
  import { getColor } from "../utilities/colors"
  import { onBeforeMount, onBeforeUnmount, inject } from 'vue'
  export default {
    name: "star",
    props: [
      'value',
    ],
    setup(props){
      const instance = new Graphics()
      const textInstance = new Text(props.value, {fontSize: 15})
      const convertToPixels = inject('convertToPixels')
      const panelHeight = inject('panelHeight')
      const addToPanel = inject('addToPanel')

      function render() {
        console.log("star - render")
        console.log(instance)
        instance.name = 'Star'
        instance.beginFill(getColor('teal', '200'))
        instance.lineStyle(2, 0x000000, 1, 1)
        drawStar(instance,
          convertToPixels(props.value), // x
          10+panelHeight/3,            // y
          5,                                // points
          panelHeight/4.5,             // radius
        )
        instance.endFill()

        instance.zIndex = 12
        addToPanel(instance)

        textInstance.anchor.set(0.5)
        textInstance.x = convertToPixels(props.value)
        textInstance.y = 5+panelHeight/3
        textInstance.zIndex = 14

        instance.addChild(textInstance)
      }
      function reRender() {
        instance.x = convertToPixels(props.value)
        textInstance.x = convertToPixels(props.value)
        textInstance.text = props.value
      }
      function drawStar(graphics, x, y, points, radius, innerRadius = radius / 2, rotation = 0) {
          const step = Math.PI / points;
          let angle = rotation;

          graphics.moveTo(
              x + Math.cos(angle) * radius,
              y + Math.sin(angle) * radius
          );

          for (let i = 0; i < points * 2; i++) {
              const r = (i % 2 === 0) ? radius : innerRadius;
              const px = x + Math.cos(angle) * r;
              const py = y + Math.sin(angle) * r;
              graphics.lineTo(px, py);
              angle += step;
          }

          graphics.closePath();
      }
      onBeforeMount(() => {
        render()
      })
      onBeforeUnmount(() => {
        instance.parent.removeChild(instance)
        instance.destroy({children: true})
      })
      return {
        reRender,
        render,
        drawStar,
        instance,
        textInstance
      }
    }
  }
</script>

<style scoped>

</style>
